PJQ.views.settings.SettingsNav = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Settings-Nav'),
        initView: null
    },
    events: {
        'click .settings-nav-item': 'navItemClicked',
        'click .cb-enable-contact-core-field-settings': 'enableContactCoreFieldSettings'
    },
    beforeFirstRender: function () {

    },
    beforeRender: function () {

    },
    afterRender: function () {
        if (this.options.subscriptionId != null && this.options.subscriptionId > 0) {
            this.renderAccountSettings(this.options.subscriptionId)
        } else {
            this.renderAccountSettings();
        }

        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });
        this.saveToolbar = new PJQ.views.toolbars.SettingsSaveToolbar({
            el: this.$('.save-toolbar-outer'),
            validate: _.bind(function () {
                if (!this.companyInfoSettings.validate()) {
                    this.$('.settings-nav-item').removeClass('active');
                    this.$('.settings-nav-content').addClass('hidden');
                    this.$('.account-item').addClass('active');
                    this.$('.settings-nav-content[data-nav="ACCOUNT"]').removeClass('hidden');
                } else {
                    return true;
                }
            }, this)
        });

        if (this.options.initView != null) {
            switch (this.options.initView) {
                case "billing":
                    if (this.companyInfoSettings != null) {
                        this.companyInfoSettings.changeCard();
                    }
                    break;
                default:
                    this.activateNavItem(this.options.initView);
            }
        }
    },
    navItemClicked: function (e) {
        let $target = $(e.currentTarget),
            tab = $target.data('nav');
        this.activateNavItem(tab);
    },
    activateNavItem: function (tab) {
        let tabUpper = tab.toUpperCase();
        this.$('.settings-nav-item').removeClass('active');
        this.$('.settings-nav-content').addClass('hidden');
        this.$('.settings-nav-item[data-nav="' + tabUpper + '"]').addClass('active');
        this.$('.settings-nav-content[data-nav="' + tabUpper + '"]').removeClass('hidden');

        PJQ.app.router.navigate('settings/' + tab.toLowerCase(), {
            trigger: false
        });

        switch (tabUpper) {
            case 'ACCOUNT':
                this.renderAccountSettings();
                break;
            case 'ADDRESSBOOK':
                this.renderAddressBookSettings();
                break;
            case 'ORDERING':
                this.renderOrderingSettings();
                break;
            case 'PROJECTS':
                this.renderProjectSettings();
                break;
            case 'BIDFORMS':
                this.renderBidFormSettings();
                break;
            case 'SCHEDULE':
                this.renderScheduleSettings();
                break;
            case 'RFI':
                this.renderRFISettings();
                break;
            case 'DAILYREPORTS':
                this.renderDailyReportSettings();
                break;
            case 'PUNCHLIST':
                this.renderPunchListSettings();
                break;
            case 'ACTIONITEMS':
                this.renderActionItemSettings();
                break;
            case 'COSTCODES':
                this.renderCostCodeSettings();
                break;
            case 'TAXCODES':
                this.renderTaxCodeSettings();
                break;
            case 'TIMECARD':
                this.renderTimeCardSettings();
                break;
            case 'PRIMECONTRACTS':
                this.renderPrimeContractSettings();
                break;
            case 'GROUPS':
                this.renderGroupSettings();
                break;
            case 'REGIONS':
                this.renderRegionSettings();
                break;
            case 'COMMITMENTS':
                this.renderCommitmentSettings();
                break;
            case 'INVOICING':
                this.renderInvoicingSettings();
                break;
            case 'DIRECTCOSTS':
                this.renderDirectCostSettings();
                break;
            case 'MEETINGS':
                this.renderMeetingSettings();
                break;
            case 'USERTYPES':
                this.renderUserTypeSettings();
                break;
            case 'USERS':
                this.renderUsers();
                break;
            case 'SSO':
                this.renderSSO();
                break;
            case 'SUBMITTALS':
                this.renderSubmittalSettings();
                break;
            case 'INTEGRATIONS':
                this.renderIntegrations();
            case 'CHANGEREQUESTS':
                this.renderChangeRequestSettings();
                break;
            case 'FEATURES':
                this.renderFeatureSettings();
                break;
        }
    },
    renderBidFormSettings: function () {
        this.bidFormSettings = new PJQ.views.bidForms.Settings({
            el: this.$('.bid-form-settings'),
            onChange: _.bind(function (model) {
                this.saveToolbar.addSaveModel(model);
            }, this),
            isDefaultSettings: true
        });

        new PJQ.views.bidForms.TemplateManagement({
            el: this.$('.bid-form-templates')
        });
    },
    renderIntegrations: function () {
        this.integrationSettings = new PJQ.integrations.views.IntegrationsList({
            el: this.$('.integrations'),
            initOptions: this.options.initOptions
        });
    },
    renderFeatureSettings: function() {
        if(!this.featureSettings) {
            this.featureSettings = new PJQ.views.featureSettings.FeatureSettings({
                el: this.$('.features-settings'),
                model: new PJQ.models.featureSettings.FeatureSetting(),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            })
        }
    },
    renderScheduleSettings: function () {
        if (this.scheduleSettings == null) {
            this.scheduleSettings = new PJQ.views.schedule.Settings({
                el: this.$('.schedule-settings'),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });

            // PJQ.app.session.fetchScheduleCustomFields(null, _.bind(function (fields) {
            // 	if (!this.scheduleFieldSettings) {
            // 		this.scheduleFieldSettings = new PJQ.views.settings.CustomFieldSettings({
            // 			el: this.$('.schedule-custom-fields'),
            // 			collection: fields,
            // 			fieldModel: PJQ.models.schedule.ScheduleCustomField
            // 		});
            // 	}
            // }, this));

            new PJQ.views.schedule.TaskStatuses({
                el: this.$('.schedule-statuses')
            });

            new PJQ.views.schedule.TemplateManagement({
                el: this.$('.template-management')
            });
        }
    },
    renderAccountSettings: function (subscriptionId) {
        if (this.companyInfoSettings == null) {
            this.companyInfoSettings = new PJQ.views.settings.CompanyInfo({
                el: this.$('.company-info'),
                procoreCode: this.options.procoreCode,
                subscriptionId: subscriptionId != null ? subscriptionId : 0,
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });
        }
    },
    renderOrderingSettings: function () {
        if (this.orderingSettings == null) {
            PJQ.app.session.fetchOrderingSettings(_.bind(function (settings) {
                this.orderingSettings = new PJQ.views.settings.PlanRoomOrderingSettings({
                    el: this.$('.ordering'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));
        }
    },
    renderAddressBookSettings: function () {
        if (this.addressBookSettings == null) {
            PJQ.app.session.fetchAddressBookSettings(_.bind(function (settings) {
                this.addressBookSettings = new PJQ.views.settings.AddressBookGeneralSettings({
                    el: this.$('.address-book-general'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));

            PJQ.app.session.fetchCompanyCustomFields(null, _.bind(function (fields) {
                if (!this.companyFieldSettings) {
                    this.companyFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.company-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.contacts.CompanyCustomField
                    });
                }
            }, this));

            PJQ.app.session.fetchContactCustomFields(null, _.bind(function (fields) {
                if (!this.contactFieldSettings) {
                    this.contactFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.contact-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.contacts.ContactCustomField
                    });
                }
            }, this));

            this.renderContactCoreFieldSettings();
        }
    },
    renderContactCoreFieldSettings: function () {
        let $fields = this.$('.contact-core-fields');
        $fields.empty();
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS)) {
            this.contactCoreFieldSettings = new PJQ.views.settings.ContactFieldSettings({
                el: $fields
            });
        } else {
            new PJQ.Alert($fields, {
                type: 'primary',
                text: 'Enable advanced settings to show this feature'
            });
        }
    },
    enableContactCoreFieldSettings: function (e) {
        let enable = $(e.currentTarget).prop('checked');
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts'
                },
                {
                    endpoint: 'fields'
                }
            ], [
                {
                    parameter: 'enable',
                    value: enable
                }
            ])
        }).put().done(_.bind(function () {
            if (enable) {
                PJQ.app.session.preferences.setPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS, enable);
            } else {
                PJQ.app.session.preferences.deletePref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
            }
            this.renderContactCoreFieldSettings();
            if (this.addressBookSettings != null) {
                this.addressBookSettings.render();
            }
        }, this));
    },
    renderProjectSettings: function () {
        if (this.planroomSettings == null) {
            PJQ.app.session.fetchPlanRoomSettings(_.bind(function (settings) {
                this.planroomSettings = new PJQ.views.settings.PlanRoomGeneralSettings({
                    el: this.$('.general'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));

            PJQ.app.session.fetchProjectCustomFields(null, _.bind(function (fields) {
                if (!this.customFieldSettings) {
                    this.customFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.project-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.projects.ProjectCustomField
                    });
                }
            }, this));

            new PJQ.views.settings.ProjectStatuses({
                el: this.$('.project-statuses')
            });

            new PJQ.views.settings.MessageStatuses({
                el: this.$('.message-statuses')
            });

            if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_STATUS_ID)) {
                PJQ.app.session.fetchProjectStatuses(_.bind(function () {
                    new PJQ.views.settings.ProjectStatusList({
                        el: this.$('.project-status-list')
                    });
                }, this));
            }

            new PJQ.views.settings.ProjectNDAs({
                el: this.$('.project-nda-outer')
            });
        }
    },
    renderRFISettings: function () {
        if (this.rfiCustomFieldSettings == null) {
            PJQ.app.session.fetchRFICustomFields(null, _.bind(function (fields) {
                this.rfiCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.rfi-custom-fields'),
                    collection: fields,
                    fieldModel: PJQ.models.rfi.CustomField
                });
            }, this));
        }

        if (this.rfiSettings == null) {
            PJQ.app.session.fetchRFISettings(_.bind(function (settings) {
                this.rfiSettings = new PJQ.views.rfi.RFISettings({
                    el: this.$('.rfi-settings'),
                    model: settings,
                    onChange: _.bind(function (model) {
                        this.saveToolbar.addSaveModel(model);
                    }, this)
                });
            }, this));
        }
    },
    renderDailyReportSettings: function () {
        if (this.dailyReportSettings == null) {
            this.dailyReportSettings = new PJQ.views.settings.DailyReportSettings({
                el: this.$('.daily-reports')
            });
        }
    },
    renderPunchListSettings: function () {
        if (this.punchListSettings == null) {
            PJQ.app.session.fetchPunchListCustomFields(null, _.bind(function (fields) {
                this.punchListSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.punch-list-custom-fields'),
                    collection: fields,
                    fieldModel: PJQ.models.punchlists.PunchlistCustomField
                });
            }, this));
        }

        if (!this.punchlistTemplates) {
            this.punchlistTemplates = new PJQ.views.punchlists.TemplateManagement({
                el: this.$('.punchlists-template-management')
            });
        }
    },
    renderActionItemSettings: function () {
        if (this.actionItemSettings == null) {
            PJQ.app.session.fetchActionItemCustomFields(null, _.bind(function (fields) {
                this.actionItemSettings = new PJQ.views.settings.CustomFieldSettings({
                    el: this.$('.action-items'),
                    collection: fields,
                    fieldModel: PJQ.models.actionItems.ActionItemCustomField
                });
            }, this));
        }

        if (!this.actionItemTemplates) {
            this.actionItemTemplates = new PJQ.views.actionItems.TemplateManagement({
                el: this.$('.actionitems-template-management')
            });
        }

    },
    renderCostCodeSettings: function () {
        if (this.costCodeSettings == null) {
            this.costCodeSettings = new PJQ.views.budget.CostCodeSettings({
                el: this.$('.cost-code-settings')
            });
        }
        if(this.costTypeSettings == null) {
            this.costTypeSettings = new PJQ.views.budget.CostTypeSettings({
                el: this.$('.cost-type-settings')
            });
        }
    },
    renderTaxCodeSettings: function () {
        if(this.taxCodeSettings == null) {
            this.taxCodeSettings = new PJQ.views.budget.TaxCodeSettings({
                el: this.$('.tax-code-settings')
            });
        }
    },
    renderTimeCardSettings: function () {
        if (this.timeCardSettingsView == null) {
            this.timeCardSettings = new PJQ.models.timecards.TimeCardSettings();
            this.timeCardSettings.fetch({
                success: _.bind(function () {
                    this.timeCardCategories = new PJQ.collections.timecards.TimeCardCategories();
                    this.timeCardCategories.fetch({
                        success: _.bind(function () {
                            this.timeCardSettingsView = new PJQ.views.settings.TimeCardSettings({
                                el: this.$('.timecard-settings'),
                                model: this.timeCardSettings,
                                categories: this.timeCardCategories,
                                saveToolbar: this.saveToolbar,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderGroupSettings: function () {
        if (this.groupSettings == null) {
            PJQ.app.session.fetchUserGroups(null, _.bind(function (groups) {
                this.groupSettings = new PJQ.views.settings.GroupSettings({
                    el: this.$('.groups'),
                    collection: groups,
                    groupModel: PJQ.models.groups.Group
                });
            }, this));

            new PJQ.views.bidPackages.TemplateManagement({
                el: this.$('.bid-package-template-management'),
                templateType: "Bid Package"
            });
        }
    },
    renderRegionSettings: function () {
        if (this.regionSettings == null) {
            this.regionSettings = new PJQ.views.settings.RegionSettings({
                el: this.$('.regions')
            });
        }
    },
    renderChangeRequestSettings: function () {
        if (!this.changeRequestSettings) {
            this.changeRequestCustomFields = new PJQ.collections.changeRequests.CustomFields();
            this.changeRequestCustomFields.fetch({
                success: _.bind(function () {
                    this.changeRequestSettings = new PJQ.models.changeRequests.Settings();
                    this.changeRequestSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.ChangeRequestSettings({
                                    el: this.$('.change-request-settings'),
                                    model: this.changeRequestSettings,
                                    customFields: this.changeRequestCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                this.changeRequestCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.change-request-custom-fields'),
                                    collection: this.changeRequestCustomFields,
                                    fieldModel: PJQ.models.changeRequests.CustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderPrimeContractSettings: function () {
        if (!this.primeContractSettings) {
            this.primeContractCustomFields = new PJQ.collections.primeContracts.CustomFields();
            this.primeContractCustomFields.fetch({
                success: _.bind(function () {
                    this.primeContractSettings = new PJQ.models.primeContracts.Settings();
                    this.primeContractSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PrimeContractSettings({
                                    el: this.$('.prime-contract-settings'),
                                    model: this.primeContractSettings,
                                    customFields: this.primeContractCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.TermsList({
                                    el: this.$('.contract-terms'),
                                    context: 'contracts'
                                })

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.prime-contract-field-settings'),
                                    context: 'primecontracts'
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.prime-contract-change-order-field-settings'),
                                    context: 'primecontractchangeorders'
                                });

                                this.primeContractCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.prime-contract-custom-fields'),
                                    collection: this.primeContractCustomFields,
                                    fieldModel: PJQ.models.primeContracts.CustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
        if (!this.primeContractCOSettings) {
            this.primeContractCOCustomFields = new PJQ.collections.primeContracts.ChangeOrderCustomFields();
            this.primeContractCOCustomFields.fetch({
                success: _.bind(function () {
                    this.primeContractCOSettings = new PJQ.models.primeContracts.ChangeOrderSettings();
                    this.primeContractCOSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PrimeContractChangeOrderSettings({
                                    el: this.$('.prime-contract-change-order-settings'),
                                    model: this.primeContractCOSettings,
                                    customFields: this.primeContractCOCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                this.primeContractCOCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.prime-contract-change-order-custom-fields'),
                                    collection: this.primeContractCOCustomFields,
                                    fieldModel: PJQ.models.primeContracts.ChangeOrderCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderCommitmentSettings: function () {
        if (!this.commitmentSettings) {
            this.commitmentCustomFields = new PJQ.collections.commitments.CustomFields();
            this.commitmentCustomFields.fetch({
                success: _.bind(function () {
                    this.commitmentSettings = new PJQ.models.commitments.Settings();
                    this.commitmentSettings.fetch({
                        success: () => {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.CommitmentSettings({
                                    el: this.$('.commitment-settings'),
                                    model: this.commitmentSettings,
                                    customFields: this.commitmentCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.TermsList({
                                    el: this.$('.commitment-terms'),
                                    context: 'commitments'
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.commitment-field-settings'),
                                    context: 'commitments'
                                });

                                this.commitmentCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.commitment-custom-fields'),
                                    collection: this.commitmentCustomFields,
                                    fieldModel: PJQ.models.commitments.CustomField
                                });
                            }, this));
                        }
                    });
                }, this)
            });
        }
        if (!this.commitmentCOSettings) {
            this.commitmentCOCustomFields = new PJQ.collections.commitments.ChangeOrderCustomFields();
            this.commitmentCOCustomFields.fetch({
                success: _.bind(function () {
                    this.commitmentCOSettings = new PJQ.models.commitments.ChangeOrderSettings();
                    this.commitmentCOSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.CommitmentChangeOrderSettings({
                                    el: this.$('.commitment-change-order-settings'),
                                    model: this.commitmentCOSettings,
                                    customFields: this.commitmentCOCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.commitment-change-order-field-settings'),
                                    context: 'commitmentchangeorders'
                                });

                                this.commitmentCOCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.commitment-change-order-custom-fields'),
                                    collection: this.commitmentCOCustomFields,
                                    fieldModel: PJQ.models.commitments.ChangeOrderCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderInvoicingSettings: function () {
        if (!this.payableInvoiceSettings) {
            this.payableInvoiceCustomFields = new PJQ.collections.invoicing.PayableInvoiceCustomFields();
            this.payableInvoiceCustomFields.fetch({
                success: _.bind(function () {
                    this.payableInvoiceSettings = new PJQ.models.invoicing.PayableInvoiceSettings();
                    this.payableInvoiceSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.PayableInvoiceSettings({
                                    el: this.$('.payable-invoice-settings'),
                                    model: this.payableInvoiceSettings,
                                    customFields: this.payableInvoiceCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.payable-invoice-field-settings'),
                                    context: 'payableinvoices'
                                });

                                this.payableInvoiceCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.payable-invoice-custom-fields'),
                                    collection: this.payableInvoiceCustomFields,
                                    fieldModel: PJQ.models.invoicing.PayableInvoiceCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
        if (!this.receivableInvoiceSettings) {
            this.receivableInvoiceCustomFields = new PJQ.collections.invoicing.ReceivableInvoiceCustomFields();
            this.receivableInvoiceCustomFields.fetch({
                success: _.bind(function () {
                    this.receivableInvoiceSettings = new PJQ.models.invoicing.ReceivableInvoiceSettings();
                    this.receivableInvoiceSettings.fetch({
                        success: _.bind(function () {
                            PJQ.app.session.fetchProjectCustomFields(PJQ.app.session.get('masterUserId'), _.bind(function () {
                                new PJQ.views.settings.ReceivableInvoiceSettings({
                                    el: this.$('.receivable-invoice-settings'),
                                    model: this.receivableInvoiceSettings,
                                    customFields: this.receivableInvoiceCustomFields,
                                    onChange: _.bind(function (model) {
                                        this.saveToolbar.addSaveModel(model);
                                    }, this)
                                });

                                new PJQ.views.settings.FinanceCoreFieldSettings({
                                    el: this.$('.receivable-invoice-field-settings'),
                                    context: 'receivableinvoices'
                                });

                                this.receivableInvoiceCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                    el: this.$('.receivable-invoice-custom-fields'),
                                    collection: this.receivableInvoiceCustomFields,
                                    fieldModel: PJQ.models.invoicing.ReceivableInvoiceCustomField
                                });
                            }, this));
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderMeetingSettings: function () {
        if (!this.meetingCustomFields) {
            this.meetingCustomFields = new PJQ.collections.meetings.CustomFields();
            this.meetingCustomFields.fetch({
                success: _.bind(function () {
                    this.meetingSettings = new PJQ.models.meetings.Settings();
                    this.meetingSettings.fetch({
                        success: _.bind(function () {
                            new PJQ.views.meetings.MeetingSettings({
                                el: this.$('.meeting-settings'),
                                model: this.meetingSettings,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });

                            this.meetingCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                el: this.$('.meeting-custom-fields'),
                                collection: this.meetingCustomFields,
                                fieldModel: PJQ.models.meetings.CustomField
                            });

                            if (!this.meetingTemplates) {
                                this.meetingTemplates = new PJQ.views.meetings.TemplateManagement({
                                    el: this.$('.meetings-template-management')
                                });
                            }
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderDirectCostSettings: function () {
        if (!this.directCostCustomFields) {
            this.directCostCustomFields = new PJQ.collections.directcosts.CustomFields();
            this.directCostCustomFields.fetch({
                success: _.bind(function () {
                    this.directCostSettings = new PJQ.models.directcosts.Settings();
                    this.directCostSettings.fetch({
                        success: _.bind(function () {
                            new PJQ.views.directcosts.DirectCostSettings({
                                el: this.$('.direct-cost-settings'),
                                model: this.directCostSettings,
                                onChange: _.bind(function (model) {
                                    this.saveToolbar.addSaveModel(model);
                                }, this)
                            });

                            this.directCostCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                                el: this.$('.direct-cost-custom-fields'),
                                collection: this.directCostCustomFields,
                                fieldModel: PJQ.models.directcosts.CustomField
                            });

                            new PJQ.views.settings.FinanceCoreFieldSettings({
                                el: this.$('.direct-cost-field-settings'),
                                context: 'directcosts'
                            });
                        }, this)
                    });
                }, this)
            });
        }
    },
    renderUserTypeSettings: function () {
        if (this.userTypeSettings == null) {
            PJQ.app.session.fetchUserTypes(_.bind(function (types) {
                this.userTypeSettings = new PJQ.views.settings.UserTypeSettings({
                    el: this.$('.user-types'),
                    collection: types,
                    model: PJQ.models.userTypes.UserType
                });
            }, this));
        }
    },
    renderUsers: function () {
        if (this.userManagement == null) {
            PJQ.app.session.fetchUsers(_.bind(function (users) {
                this.userManagement = new PJQ.views.settings.UserSettings({
                    el: this.$('.user-management'),
                    collection: users
                });
            }, this));

            PJQ.app.session.fetchUserCustomFields(null, _.bind(function (fields) {
                if (!this.userCustomFieldSettings) {
                    this.userCustomFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.user-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.users.UserCustomField
                    });
                }
            }, this));
        }
    },
    renderSSO: function () {
        if (this.ssoSettings == null) {
            PJQ.app.session.fetchSSOProviders(_.bind(function (providers) {
                this.ssoSettings = new PJQ.views.settings.SSOSettings({
                    el: this.$('.sso-settings'),
                    collection: providers
                });
            }, this));
        }
    },
    renderSubmittalSettings: function () {
        if (this.submittalSettings == null) {
            this.submittalSettings = new PJQ.views.submittals.Settings({
                el: this.$('.submittal-settings'),
                onChange: _.bind(function (model) {
                    this.saveToolbar.addSaveModel(model);
                }, this)
            });
            if (!this.submittalTemplates) {
                this.submittalTemplates = new PJQ.views.submittals.TemplateManagement({
                    el: this.$('.submittal-template-management')
                });
            }
            if(!this.submittalStatuses){
                this.submittalStatuses = new PJQ.views.submittals.SubmittalStatusSettings({
                    el: this.$('.submittal-status-settings')
                })
            }
            // if(!this.submittalItemTypes){
            // 	this.submittalItemTypes = new PJQ.views.submittals.ItemTypeSettings({
            // 		el: this.$('.submittal-item-type-settings')
            // 	})
            // }
            PJQ.app.session.fetchSubmittalCustomFields(null, _.bind(function (fields) {
                if (!this.submittalFieldSettings) {
                    this.submittalFieldSettings = new PJQ.views.settings.CustomFieldSettings({
                        el: this.$('.submittal-custom-fields'),
                        collection: fields,
                        fieldModel: PJQ.models.submittals.SubmittalCustomField
                    });
                }
            }, this));
        }
    }
});
